module.exports = __webpack_public_path__ + "img/qualification.d7e7f0b2.svg";